import { Outlet } from 'react-router-dom';

import { RequireAdmin } from '../../components/routes/require-admin';
import { FeatureFlag } from '../../lib/who-am-i';

export const AwardsRoot = () => {
	return (
		<RequireAdmin require="awards">
			<FeatureFlag flag="awards-redesign" fallback={<h1>Awards redesign not enabled</h1>}>
				<Outlet />
			</FeatureFlag>
		</RequireAdmin>
	);
};
